import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { FullHistoryAndGamesModalGreenbet } from './FullHistoryAndGamesModalGreenbet'


interface Props {
    show: boolean
    handleClose: () => void
    bonificationsData: any
    form: any
    handleSubtractCoins: ({ validated }: { validated?: boolean }) => void
}

export const ConfirmBonificationNotUsed = ({ show, handleClose, bonificationsData, form, handleSubtractCoins }: Props) => {

    const [showFullHistoryAndGamesModal, setShowFullHistoryAndGamesModal] = useState(false)
    console.log(bonificationsData)
    const sumAllBonifications =
        bonificationsData?.nonUsedBonifications?.reduce((acc: number, curr: any) => {
            const raw = curr?.[4];
            const clean = raw.replace(/\./g, '').replace(',', '.');
            const num = Math.abs(Number(clean));
            return acc + num;
        }, 0);


    // Add a dot every 3 digits
    const formattedQuantity = Number(form.quantity).toLocaleString('es-AR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });

    const formattedTotalAmount = Number(bonificationsData?.totalAmount).toLocaleString('es-AR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });

    const handleConfirm = () => {
        handleSubtractCoins({ validated: true })
        handleClose()
    }

    return (
        <>
            {showFullHistoryAndGamesModal &&
                <FullHistoryAndGamesModalGreenbet
                    show={showFullHistoryAndGamesModal}
                    handleClose={() => setShowFullHistoryAndGamesModal(false)}
                    bonificationsData={bonificationsData}
                />
            }

            <Modal show={show} onHide={handleClose} centered={true} size="lg" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Confirmación de Bonificación no usada
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className='text-center text-primary text-lg'>
                        ¿Estás seguro de querer bajar {formattedQuantity} fichas?
                    </p>

                    <p className='text-warning'>Su saldo actual es de {formattedTotalAmount} fichas.</p>

                    <p>Al usuario {bonificationsData?.nonUsedBonifications?.[0]?.[1]} se le han cargado un total de <span className='text-warning'>{sumAllBonifications}</span> fichas bonificadas en las siguientes transacciones:</p>

                    <table className='table table-bordered'>
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Bonificación</th>
                            </tr>
                                {bonificationsData?.nonUsedBonifications?.map((item: any) => (
                                    <tr key={item?.[0]}>
                                        <td>{item?.[0]}</td>
                                        <td>{item?.[4].replace('-', '')}</td>
                                </tr>
                            ))}
                        </thead>
                    </table>

                    <div className='text-center'>
                        <span className='text-warning'>Es probable que debas restarle las fichas bonificadas a la cantidad que ha solicitado retirar.</span>
                        <br />
                        <span className='text-primary'>Revisa el historial de transacciones si tienes dudas.</span>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex justify-content-between w-100'>
                        <div className='d-flex justify-content-start'>
                            <Button variant='dark' onClick={() => setShowFullHistoryAndGamesModal(true)}>Ver todo el historial</Button>
                        </div>
                        <div className='d-flex justify-content-end gap-2'>
                            <Button variant='dark' onClick={handleClose}>Cancelar</Button>
                            <Button variant='success' onClick={handleConfirm}>Si, bajar {formattedQuantity} fichas</Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal >
        </>
    )
}
